import React from "react";
import styles from "./Footer.module.scss";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import Logo1 from "../../images/IMG_1969.PNG";
import Logo2 from "../../images/IMG_1971.PNG";

const Footer = () => {
  return (
    <footer className={styles.footer} role="contentinfo" aria-label="Podnožje"> {/* Dodajemo role i aria-label */}
      <div className={styles.content}>
        <img src={Logo1} alt="Plesna škola Escape Logo" className={styles.logo}/>
        <img id={styles.logo2} src={Logo2} alt="Plesna škola Escape Logo" className={styles.logo}/>
        <p>&copy; {new Date().getFullYear()} Plesni studio Escape. Sva prava zadržana.</p>
        <div className={styles.socials}>
          <a href="https://www.instagram.com/plesna_skola_escape/" target="_blank" rel="noopener noreferrer">
            <FaInstagram/>
          </a>
          <a href="https://www.facebook.com/people/Escape-Plesna-Skola/61571239581097/?sk=reels_tab" target="_blank" rel="noopener noreferrer">
            <FaFacebook/>
          </a>
          <a href="https://www.tiktok.com/@plesnistudioescap" target="_blank" rel="noopener noreferrer">
            <FaTiktok/>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;